(function(){
'use strict';
function all(root,sel){return Array.from((root||document).querySelectorAll(sel))}
function cleanCardTitles(root){
 all(root||document,'.card>.card__content>.card__information .card__heading a').forEach(function(link){
  if(link.dataset.tlcTitleClean==='1')return;
  var full=(link.textContent||'').replace(/\s+/g,' ').trim(),name=full;
  name=name.replace(/^Kindle,\s*Kobo\s*&\s*ColorSoft Skin\s*-\s*/i,'').replace(/^Kindle\s*&\s*Kobo Skin\s*-\s*/i,'').replace(/^Kindle,\s*Kobo\s*&\s*Colorsoft Skin\s*-\s*/i,'');
  if(name===full)return;
  link.dataset.tlcTitleClean='1';link.dataset.fullTitle=full;link.setAttribute('aria-label',full);link.textContent=name;
  var info=link.closest('.card__information');
  if(info&&!info.querySelector('.tlc-v11-device-line')){
   var line=document.createElement('span');line.className='tlc-v11-device-line';line.textContent=/colorsoft/i.test(full)?'Kindle · Kobo · ColorSoft':'Kindle · Kobo';link.closest('.card__heading').insertAdjacentElement('afterend',line);
  }
 });
}
function boot(){
 var root=document.querySelector('[data-tlc-v11-product-grid]');if(!root||root.dataset.tlcV11Booted==='1')return;
 root.dataset.tlcV11Booted='1';cleanCardTitles(root);
 if(window.MutationObserver){
  var queued=false;
  new MutationObserver(function(){if(queued)return;queued=true;requestAnimationFrame(function(){queued=false;cleanCardTitles(root)})}).observe(root,{childList:true,subtree:true});
 }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();